import React, { useState, useEffect, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';

import ButtonStyles from './buttonStyles';

const Button = forwardRef((props, ref) => {
  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(props.isLoading);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  });

  useEffect(() => {
    if (isMounted.current) {
      setIsLoading(props.isLoading);
    }
  }, [props.isLoading]);

  const disabled = isLoading ? true : props.disabled;

  const handleOnClick = async e => {
    if (isLoading) {
      e.preventDefault();
      return;
    }

    setIsLoading(true);
    await props.onClick(e);
    if (isMounted.current) {
      setIsLoading(false);
    }
  };

  return (
    <ButtonStyles
      ref={ref}
      {...props}
      disabled={disabled}
      onClick={props.onClick ? handleOnClick : undefined}
    >
      {props.children}
      {isLoading && ' ...'}
    </ButtonStyles>
  );
});

Button.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'inverse']),
  large: PropTypes.bool,
  width: PropTypes.number,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

Button.defaultProps = {
  isLoading: false,
  disabled: false,
  active: false,
  variant: undefined,
  large: undefined,
  width: undefined,
};

export default Button;
